import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { FilterSectionLegacy } from "web_myplann/NotificationCenter/FilterScreen/FilterSectionLegacy";
import { FilterSectionV2 } from "web_myplann/NotificationCenter/FilterScreen/FilterSectionV2";
import type { FilterSectionProps } from "web_myplann/NotificationCenter/Types/FilterSectionProps";

export const FilterSection: FC<FilterSectionProps> = (props) => {
	const hasGoalsRight = useGoalsRightOptional();

	return hasGoalsRight ? (
		<FilterSectionV2 {...props} />
	) : (
		<FilterSectionLegacy {...props} />
	);
};
